import SiteNav from '@/components/organisms/SiteNav'
import FooterStub from '@/components/organisms/FooterStub'
import SiteButton from '@/components/atoms/SiteButton'
import ProductsSection from '@/features/homepage/components/ProductsSection'
import constructionIllustration from '@/assets/illustrations/industry card construction desktop.svg'

// Event details and the event-specific HubSpot embed are awaiting confirmation.
// Keep this on a review route until real availability and booking are verified.
export function UKConstructionWeekPage() {
    return (
        <div className="min-h-screen bg-unimo-stone">
            <div className="site-shell">
                <SiteNav />
                <main>
                    <section className="grid overflow-hidden rounded-site-panel bg-unimo-site-turquoise-light lg:grid-cols-2">
                        <div className="px-8 py-12 lg:p-16">
                            <p className="text-sm font-medium uppercase tracking-widest text-unimo-slate">UK Construction Week</p>
                            <h1 className="mt-6 text-4xl font-medium leading-tight text-unimo-slate lg:text-5xl">
                                Let’s meet at UK Construction Week.
                            </h1>
                            <p className="mt-6 text-lg font-light leading-relaxed text-unimo-slate">
                                Book a one-to-one with the unimo team. Bring your site challenges
                                and we’ll explore them together.
                            </p>
                            <SiteButton href="#book-a-meeting" className="mt-8">Meeting availability</SiteButton>
                        </div>
                        <img src={constructionIllustration} alt="" className="h-64 w-full object-cover object-right lg:h-full" />
                    </section>

                    <ProductsSection variant="construction" heading="Make the conversation about your site." />

                    <section id="book-a-meeting" className="scroll-mt-8 pt-section-gap">
                        <div className="rounded-site-panel border-[3px] border-unimo-site-turquoise bg-white p-8 lg:p-12">
                            <h2 className="text-2xl font-medium text-unimo-slate lg:text-4xl">Meet us one-to-one.</h2>
                            <p className="mt-4 max-w-2xl font-light leading-relaxed text-unimo-slate">
                                Meeting bookings will open here soon. Event dates, where to find us,
                                and available times will be added before booking opens.
                            </p>
                        </div>
                    </section>
                </main>
                <FooterStub />
            </div>

        </div>
    )
}
